import { capitalize } from './string';

const getPlatform = (): string =>
  navigator.userAgentData?.platform || navigator?.platform || 'unknown';

const isMac = (): boolean => /MAC/.test(getPlatform().toUpperCase());

// Translate a `react-hotkeys-hook`-style combo (e.g. "meta+shift+k") into
// a human-readable, platform-aware label (e.g. "⌘ ⇧ K" on Mac, "Ctrl Shift K"
// elsewhere). Pairs with `useHotkeys` in `react-hotkeys-hook`.
export const formatHotkey = (hotkey: string | undefined): string => {
  if (!hotkey) return '';

  return hotkey
    .toLowerCase()
    .split('+')
    .map(part => {
      switch (part.trim()) {
        case 'meta':
        case 'mod':
          return isMac() ? '⌘' : 'Ctrl';
        case 'alt':
          return isMac() ? '⌥' : 'Alt';
        case 'shift':
          return isMac() ? '⇧' : 'Shift';
        case 'ctrl':
          return isMac() ? '⌃' : 'Ctrl';
        case 'up':
          return '↑';
        case 'down':
          return '↓';
        case 'v':
          return 'v';
        case 'enter':
        case 'return':
          return isMac() ? '⏎' : 'Enter';
        default:
          return part.length === 1 ? part.toUpperCase() : capitalize(part);
      }
    })
    .join(' ');
};
